import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Close from 'src/assets/images/CloseProduct.svg';
import { Grid } from '@material-ui/core';
import moment from 'moment';
import {
    User,
    Username,
    Name,
    Designation,
    By,
    PopupContainer,
    HeaderTextContainer1,
    HeaderTextContainer2,
    HeaderTextContainer3,
    To,
    ValidContainer,
    CloseIcon,
    From,
    Line,
    Container,
    ContainerGrid,
    HeaderTextContainer4,
    Container1,
    ContainerGrid1,
    Container2,
    TextBold,
    BottomNavigationButtonContainer,
    UpdateProxyPopupContainer,
    AddProxyPopupMainContainer,
} from './index.styled';
import Datepicker from 'src/common/components/datePicker/DatePicker';
import Calendar from 'src/assets/images/CalendarTodayBlue.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import {
    setCommonCancel,
    setIsEdit,
} from 'src/pages/more/redux/actions/index.js';
import UserEmphasis from 'src/assets/images/UserEmphasis.svg';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import RevokeProxy from 'src/pages/admin/revokeProxy';
import { useTranslation } from 'react-i18next';
import { updateProxies } from 'src/pages/admin/redux/action';
import { getPlaceholderDateFormat } from 'src/utils/dateUtils';
import { isMobileDevice } from 'src/utils/util';

const UpdateProxy = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [revokeProxyData, setRevokeProxyData] = useState({});
    const [showRevokeProxy, setshowRevokeProxy] = useState(false);
    const [revokeProxy] = useState(false);
    const [apply, setApply] = useState(false);
    const [applyStart, setApplyStart] = useState(false);
    const openRevokeProxy = (data) => {
        setRevokeProxyData(data);
        setshowRevokeProxy(true);
    };
    const setLoader = props.setLoader;
    const closeRevokeProxy = () => {
        setLoader(false);
        setRevokeProxyData({});
        setshowRevokeProxy(false);
    };
    
    const onSave = () => {
        let params = {
            startDate: moment(selectedStartDate).format('MM-DD-YYYY'),

            endDate:
                selectedEndDate === ''
                    ? ''
                    : moment(selectedEndDate).format('MM-DD-YYYY'),
            proxyId: props.proxyData.proxyUid,
        };
        setLoader(true);
        dispatch(updateProxies(params));
        dispatch(setIsEdit(false));
        props.handleClose();
    };

    const onCancel = () => {
        dispatch(setCommonCancel(true));
        dispatch(setIsEdit(false));
        props.handleClose();
    };

    const [selectedStartDate, setselectedStartDate] = useState(
        moment(
            props.proxyData.fromDate && props.proxyData.fromDate.split('T')[0]
        ).format(t('dateFormat'))
    );
    const [selectedEndDate, setselectedEndDate] = useState(
        props.proxyData.toDate
            ? moment(
                  props.proxyData.toDate && props.proxyData.toDate.split('T')[0]
              ).format(t('dateFormat'))
            : ''
    );

    const handleInputStartDateChange = (date) => {
        if (
            date !== '' &&
            !moment(date).isSame(moment(props.proxyData.fromDate), 'day')
        ) {
            setApplyStart(true);
        } else {
            setApplyStart(false);
        }
        if (date === '') {
            setselectedStartDate(
                moment(
                    props.proxyData.fromDate &&
                        props.proxyData.fromDate.split('T')[0]
                ).format(t('dateFormat'))
            );
            setselectedEndDate(
                props.proxyData.toDate
                    ? moment(
                          props.proxyData.toDate &&
                              props.proxyData.toDate.split('T')[0]
                      ).format(t('dateFormat'))
                    : ''
            );
        } else {
            setselectedStartDate(date);
        }
        if (
            moment(
                props.proxyData.toDate && props.proxyData.toDate.split('T')[0]
            ).isBefore(moment(date), 'day') &&
            selectedEndDate !== '' &&
            date !== ''
        ) {
            setselectedEndDate(moment(date).format(t('dateFormat')));
        }
    };
    const handleInputEndDateChange = (date) => {        
        if (
            date !== '' &&
            moment(date).isSameOrAfter(moment(props.proxyData.fromDate), 'day')
        ) {
            setApply(true);
        } else {
            setApply(false);
        }
        if (date === '') {
            setselectedEndDate(
                props.proxyData.toDate
                    ? moment(
                          props.proxyData.toDate &&
                              props.proxyData.toDate.split('T')[0]
                      ).format(t('dateFormat'))
                    : ''
            );
        } else {
            setselectedEndDate(date);
        }
    };
    const currentDate = new Date();
    return (
        <>
            <UpdateProxyPopupContainer>
                <Container1
                    container
                    justifyContent={'space-between'}
                    direction="row"
                    alignItems="center"
                >
                    <ContainerGrid1
                        item
                        xs={11}
                        sm={11}
                        md={11}
                        lg={11}
                        xl={11}
                        mobile={6}
                    >
                        <HeaderTextContainer1>
                            {t('proxies.updateAProxy.title')}
                        </HeaderTextContainer1>
                    </ContainerGrid1>
                    <ContainerGrid1
                        item
                        xs={1}
                        sm={1}
                        md={1}
                        lg={1}
                        xl={1}
                        mobile={6}
                    >
                        <CloseIcon
                            mobilePath={Close}
                            onClick={props.handleClose}
                            show={true}
                        />
                    </ContainerGrid1>
                </Container1>
                <HeaderTextContainer2>
                    {t('proxies.updateAProxy.heading')}
                </HeaderTextContainer2>
                <HeaderTextContainer3
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    mobile={6}
                >
                    {t('proxies.updateAProxy.user')}
                </HeaderTextContainer3>
                <div
                    style={{
                        margin: 'auto',
                        display: 'inline-flex',
                        padding: '11.88px 0 0 0',
                    }}
                >
                    <img
                        src={UserEmphasis}
                        alt={'.png'}
                        width={'31.7px'}
                        height={'31.7px'}
                    />
                    <User>
                        <Username>
                            {props.proxyData &&
                                props.proxyData.user &&
                                props.proxyData.user.displayName}
                        </Username>
                        <Designation style={{ margin: '5px 0 0 0' }}>
                            {props.proxyData &&
                                props.proxyData.user &&
                                props.proxyData.user.employeeRole}
                        </Designation>
                    </User>
                </div>

                <ValidContainer>
                    <HeaderTextContainer4>
                        {t('proxies.updateAProxy.validDates')}
                    </HeaderTextContainer4>

                    <Container
                        container
                        justifyContent={'space-between'}
                        direction="row"
                    >
                        <ContainerGrid
                            item
                            xs={12}
                            sm={3}
                            md={6}
                            lg={6}
                            xl={6}
                            mobile={12}
                        >
                            <From>
                                {t('proxies.updateAProxy.from')}{' '}
                                <span style={{ color: '#FF0000' }}> * </span>
                            </From>
                            <Container2>
                                <Datepicker
                                    datePickerCalendarIcon={Calendar}
                                    minDate={
                                        new Date(currentDate.toDateString())
                                    }
                                    // maxDate={new Date(selectedEndDate)}
                                    onChange={(date) =>
                                        handleInputStartDateChange(date)
                                    }
                                    selectedDateFromDatePicker={
                                        new Date(selectedStartDate)
                                    }
                                    fontSize="16px"
                                    left="10px"
                                    mobileHeight="40px"
                                    yearRange={`${new Date().getFullYear()}:2999`}
                                    datePickerBgColor="white"
                                    datePickerDivWidth="200px"
                                    datePickerDivHeight="40px"
                                    iconHeight={'auto'}
                                    border={'2px solid #EBEDED'}
                                    textOpacity={0.5}
                                    Zindex={99999}
                                    datePickerDivMbWidth={'217px'}
                                    datePickerDivMbHeight={'40px'}
                                />
                                <div
                                    style={{ position: 'relative !important' }}
                                />
                            </Container2>
                        </ContainerGrid>
                        <ContainerGrid
                            item
                            xs={12}
                            sm={3}
                            md={6}
                            lg={6}
                            xl={6}
                            mobile={12}
                            key="accountName"
                            ipadMarginRight={'8% !important'}
                        >
                            <To>
                                {t('proxies.updateAProxy.to')}{' '}
                                <span style={{ color: '#FF0000' }}> * </span>
                            </To>
                            <Container2>
                                <Datepicker
                                    datePickerCalendarIcon={Calendar}
                                    minDate={
                                        // selectedEndDate === '' ||
                                        moment(new Date()).isAfter(
                                            new Date(selectedStartDate)
                                        )
                                            ? new Date()
                                            : new Date(selectedStartDate)
                                    }
                                    placeholder={getPlaceholderDateFormat()}
                                    onChange={(date) =>
                                        handleInputEndDateChange(date)
                                    }
                                    selectedDateFromDatePicker={
                                        selectedEndDate === ''
                                            ? ''
                                            : new Date(selectedEndDate)
                                    }
                                    fontSize="16px"
                                    left="10px"
                                    mobileHeight="40px"
                                    yearRange={`${new Date().getFullYear()}:2999`}
                                    datePickerBgColor="white"
                                    datePickerDivWidth="200px"
                                    datePickerDivHeight="40px"
                                    iconHeight={'auto'}
                                    border={'2px solid #EBEDED'}
                                    textOpacity={0.5}
                                    Zindex={99999}
                                    datePickerDivMbWidth={'217px'}
                                    datePickerDivMbHeight={'40px'}
                                />
                                <div
                                    style={{ position: 'relative !important' }}
                                />
                            </Container2>
                        </ContainerGrid>
                    </Container>
                </ValidContainer>
                <Grid
                    container
                    justifyContent={'space-between'}
                    direction="row"
                >
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        xl={6}
                        mobile={12}
                        key="accountName"
                        ipadMarginRight={'8% !important'}
                    >
                        <By>{t('proxies.updateAProxy.createdby')}</By>
                        <div style={{ display: 'inline-flex' }}>
                            <Name>
                                {props.proxyData &&
                                    props.proxyData.createdByEmployee &&
                                    props.proxyData.createdByEmployee
                                        .displayName}
                            </Name>
                            <Designation>
                                {props.proxyData &&
                                    props.proxyData.createdByEmployee &&
                                    props.proxyData.createdByEmployee &&
                                    props.proxyData.createdByEmployee
                                        .employeeRole}
                            </Designation>
                        </div>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        xl={6}
                        mobile={12}
                        key="accountName"
                        ipadMarginRight={'8% !important'}
                    >
                        <By>{t('proxies.updateAProxy.modifiedby')}</By>
                        <div style={{ display: 'inline-flex' }}>
                            <Name>
                                {props.proxyData &&
                                    props.proxyData.modifiedByEmployee &&
                                    props.proxyData.modifiedByEmployee
                                        .displayName}
                            </Name>
                            <Designation>
                                {props.proxyData &&
                                    props.proxyData.modifiedByEmployee &&
                                    props.proxyData.modifiedByEmployee &&
                                    props.proxyData.modifiedByEmployee
                                        .employeeRole}
                            </Designation>
                        </div>
                    </Grid>
                </Grid>
                <Line />

                <BottomNavigationButtonContainer
                    ipadPadding={'0px 0px 0px 0px'}
                    mbPadding={'0px 0px 0px 0px'}
                    justifyContent={'space-between'}
                    mbPosition={'absolute'}
                    moblieJustifyContent={'center'}
                    smallJustifyContent  = {'space-between'}
                >
                 {!isMobileDevice() ? (  <>
                  <div style={{ justifyContent: 'flex-start' }}>
                        <Button
                            id={'page-admin-updateProxy-revoke1'}
                            show={true}
                            variant={ButtonStyles.secondary}
                            width={'102px'}
                            height={'38px'}
                            justifyContent={'flex-start'}
                            border={'1px solid #ED002A'}
                            color={'#ED002A'}
                            margin={'16px 5px 0px 0'}
                            fontSizeMobile={'13px'}
                        >
                            {' '}
                            <a onClick={() => openRevokeProxy(props.proxyData)}>
                                <TextBold>
                                    {t('proxies.updateAProxy.revoke')}
                                </TextBold>
                            </a>
                        </Button>
                    </div>

                    <div
                        style={{
                            justifyContent: 'flex-end',
                            display: 'inline-flex',
                        }}
                    >
                        <Button
                           id={'page-admin-updateProxy-cancel'}
                            clearNotes
                            show={true}
                            variant={ButtonStyles.cancel}
                            width={'102px'}
                            height={'38px'}
                            margin={'16px 4px 0px 4px'}
                            mobileMargin={'15px 9px 10px 5px'}
                            clicked={onCancel}
                            fontSizeMobile={'13px'}
                        >
                            <TextBold color={'#140F4B'}>
                                {t('proxies.updateAProxy.cancel')}
                            </TextBold>
                        </Button>

                        <Button
                            id={'page-admin-updateProxy-save'}
                            show
                            disabled={!apply && !applyStart ? true : false}
                            variant={
                                (apply || applyStart)
                                    ? ButtonStyles.primary
                                    : ButtonStyles.disabled
                            }
                            width={'102px'}
                            height={'38px'}
                            mobileMargin={'15px 0px 10px 0px'}
                            margin={'16px 4px 0px 4px'}
                            clicked={onSave}
                            fontSizeMobile={'13px'}
                        >
                            <TextBold color={'#FFFF'}>
                                {t('proxies.updateAProxy.save')}
                            </TextBold>
                        </Button>
                    </div></>) : (  <>  
                    
                               <div style={{ justifyContent: 'flex-start' }}>
     <Button
                            id={'page-admin-updateProxy-revoke'}
                            show={true}
                            variant={ButtonStyles.secondary}
                            width={'102px'}
                            height={'38px'}
                            justifyContent={'flex-start'}
                            border={'1px solid #ED002A'}
                            color={'#ED002A'}
                            margin={'16px 5px 0px 0'}
                            fontSizeMobile={'13px'}
                        >
                            {' '}
                            <a onClick={() => openRevokeProxy(props.proxyData)}>
                                <TextBold>
                                    {t('proxies.updateAProxy.revoke')}
                                </TextBold>
                            </a>
                        </Button>
                        </div>
                           <div
                        style={{
                            justifyContent: 'flex-end',
                            display: 'inline-flex',
                        }}
                    >
                        <Button
                           id={'page-admin-updateProxy-cancel'}
                            clearNotes
                            show={true}
                            variant={ButtonStyles.cancel}
                            width={'102px'}
                            height={'38px'}
                            margin={'16px 4px 0px 4px'}
                            mobileMargin={'15px 9px 10px 5px'}
                            clicked={onCancel}
                            fontSizeMobile={'13px'}
                        >
                            <TextBold color={'#140F4B'}>
                                {t('proxies.updateAProxy.cancel')}
                            </TextBold>
                        </Button>
                        <Button
                            id={'page-admin-updateProxy-save'}
                            show
                            disabled={!apply && !applyStart ? true : false}
                            variant={
                                (apply || applyStart)
                                    ? ButtonStyles.primary
                                    : ButtonStyles.disabled
                            }
                            width={'102px'}
                            height={'38px'}
                            mobileMargin={'15px 0px 10px 0px'}
                            margin={'16px 4px 0px 4px'}
                            clicked={onSave}
                            fontSizeMobile={'13px'}
                        >
                            <TextBold color={'#FFFF'}>
                                {t('proxies.updateAProxy.save')}
                            </TextBold>
                        </Button></div></>)}
                </BottomNavigationButtonContainer>
                {showRevokeProxy && (
                    <AddProxyPopupMainContainer>
                        <Popup id={'admin-updateProxy-index-popup'} contentWidth={'50%'} margin={'15px'}>
                            <PopupContainer>
                                <RevokeProxy
                                    addProxyPopup={revokeProxy}
                                    handleClose={closeRevokeProxy}
                                    isFromAccount={props.isFromAccount}
                                    revokeProxyData={revokeProxyData}
                                />
                            </PopupContainer>
                        </Popup>
                    </AddProxyPopupMainContainer>
                )}
            </UpdateProxyPopupContainer>
        </>
    );
};
export default UpdateProxy;
